import { SignIn } from "@clerk/clerk-react";
import { agentPublicAuthAppearance } from "../clerkAppearance";

/**
 * Public entry: centered sign-in (no agent nav). Signed-in users use AgentShell routes only.
 */
export function AgentLanding() {
  return (
    <div
      style={{
        minHeight: "100%",
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "clamp(1.25rem, 4vw, 2rem)",
      }}
    >
      <header style={{ textAlign: "center", marginBottom: "1.5rem", maxWidth: "22rem" }}>
        <div style={{ fontWeight: 800, fontSize: "1.45rem", letterSpacing: "-0.04em" }}>SurgeDial</div>
        <p style={{ margin: "0.35rem 0 0", fontSize: "0.9rem", color: "var(--sdw-muted)", fontWeight: 500 }}>
          Agent Login
        </p>
      </header>
      <div className="sdw-clerk-auth" style={{ width: "100%", maxWidth: "24rem", minWidth: 0 }}>
        <SignIn routing="virtual" signUpUrl="/sign-up" appearance={agentPublicAuthAppearance} />
      </div>
    </div>
  );
}
